import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { SALES_TAX_PATH } from '../../../../config/paths';
import { clearSalesTax, getSalesTax } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import SalesTaxToolbar from './SalesTaxToolbar';
import NoDataResource from '../../../common/resource/NoDataResource';
import SalesTaxBasicInformationResource from './resource/SalesTaxBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const SalesTax = ({
  breadcrumbs,
  match: {
    params: { id: salesTaxId },
  },
  salesTax,
  loading,
  dispatchGetSalesTax,
  dispatchClearSalesTax,
}) => {
  useLayoutEffect(() => {
    dispatchGetSalesTax({ salesTaxId });

    return () => dispatchClearSalesTax();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (salesTax.isEmpty()) {
    content = <NoDataResource returnPage={SALES_TAX_PATH} />;
  } else {
    const salesTaxJSON = salesTax.toJS();
    content = (
            <>
              <h3>Información Básica</h3>
              <SalesTaxBasicInformationResource {...salesTaxJSON} />
              <InternalResource id={salesTaxJSON.id}
                        createDate={salesTaxJSON.createDate}
                        lastUpdate={salesTaxJSON.lastUpdate}/>
            </>
      
  );
    toolbar = <SalesTaxToolbar salesTaxId={salesTaxJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Impuesto a la Venta"
      toolbar={toolbar}
      content={content}
    />
  );
};

SalesTax.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  salesTax: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetSalesTax: PropTypes.func.isRequired,
  dispatchClearSalesTax: PropTypes.func.isRequired,
};

SalesTax.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Impuestos a la Venta',
      href: SALES_TAX_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  salesTax: AccountingUnit.SalesTax.getIn(['current', 'content']),
  loading: !AccountingUnit.SalesTax.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetSalesTax: getSalesTax,
  dispatchClearSalesTax: clearSalesTax,
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesTax);
